<template>
    <v-container>
        <FavoriteChip
            :favoritelist="favoritesList"
            @remove="remove"
        />
        <v-row>
            <v-col
                md="5"
                lg="4"
            >
                <v-row justify="center">
                    <v-col
                        xs="10"
                        sm="8"
                        md="12"
                    >
                        <v-card
                            class="player ml-4 mr-4 mb-4 mb-10 pa-8 elevation-15"
                            :style="'background-color: rgb(' + this.playerBgColors[0] + ',' + this.playerBgColors[1] + ',' + this.playerBgColors[2] + ' !important;'"
                        >
                            <div class="sound">
                                <button
                                    @click="mute()"
                                    v-if="!this.muted"
                                >
                                    <v-icon small>
                                        mdi-volume-high
                                    </v-icon>
                                </button>
                                <button
                                    v-else
                                    @click="mute()"
                                >
                                    <v-icon small>
                                        mdi-volume-variant-off
                                    </v-icon>
                                </button>
                                <div class="slider">
                                    <v-slider
                                        max="50"
                                        min="-50"
                                        vertical
                                        value="0"
                                        @change="volumeChange($event)"
                                    />
                                </div>
                            </div>
                            <div class="image">
                                <img
                                    class="elevation-5"
                                    :src="currentSong.imagePath"
                                    :alt="currentSong.name"
                                >
                            </div>
                            <div class="title">
                                {{ currentSong.name }}
                            </div>
                            <p
                                class="artist"
                                @click="playerPause()"
                            >
                                <router-link :to="'/artist/' + currentSong.index">
                                    {{ currentSong.artist }}
                                </router-link>
                            </p>
                            <div class="progress-bar">
                                <div class="times d-flex justify-space-between">
                                    <p>{{ currentTimer }}</p>
                                    <p>{{ audioMaxTimer }}</p>
                                </div>
                                <v-slider
                                    max="100"
                                    min="0"
                                    height="8"
                                    :value="audio.percent"
                                    @change="changeAudioTime($event)"
                                />
                            </div>
                            <div class="action-bar d-flex justify-space-between align-center">
                                <v-icon
                                    small
                                    v-if="!currentSong.favoriteMarked"
                                    @click="addToFavorite(currentSong.index)"
                                >
                                    mdi-heart-outline
                                </v-icon>
                                <v-icon
                                    small
                                    v-else
                                    @click="addToFavorite(currentSong.index)"
                                >
                                    mdi-heart
                                </v-icon>
                                <div class="buttons d-flex justify-center align-center">
                                    <button
                                        :class="{ hidden: isFirstSong }"
                                        @click="previous()"
                                    >
                                        <v-icon small>
                                            mdi-skip-backward
                                        </v-icon>
                                    </button>
                                    <button
                                        v-if="!isPlaying"
                                        @click="playerPlay()"
                                    >
                                        <v-icon
                                            x-large
                                            class="mr-2 ml-2"
                                        >
                                            mdi-play-circle
                                        </v-icon>
                                    </button>
                                    <button
                                        v-else
                                        @click="playerPause()"
                                    >
                                        <v-icon
                                            x-large
                                            class="mr-2 ml-2"
                                        >
                                            mdi-pause-circle
                                        </v-icon>
                                    </button>
                                    <button
                                        :class="{ hidden: isLastSong }"
                                        @click="next()"
                                    >
                                        <v-icon small>
                                            mdi-skip-forward
                                        </v-icon>
                                    </button>
                                </div>
                                <v-menu offset-y>
                                    <template #activator="{ on, attrs }">
                                        <v-btn
                                            v-bind="attrs"
                                            v-on="on"
                                            icon
                                            small
                                        >
                                            <v-icon small>
                                                mdi-dots-vertical
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <v-list>
                                        <v-list-item
                                            v-for="(item, index) in moreItems"
                                            :key="index"
                                            @click="item.action"
                                        >
                                            {{ item.title }}
                                        </v-list-item>
                                    </v-list>
                                </v-menu>
                            </div>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
            <v-col
                md="7"
                lg="8"
            >
                <v-row
                    class="playlist"
                    justify="center"
                >
                    <v-col
                        xs="10"
                        md="12"
                        class="d-flex flex-column"
                    >
                        <v-text-field
                            v-model="search"
                            type="search"
                            label="Solo"
                            placeholder="Rechercher une musique"
                            prepend-inner-icon="mdi-magnify"
                            solo
                            rounded
                            clearable
                        />
                        <v-card
                            class="song pa-3"
                            v-for="(song, index) in filterSongs"
                            :key="index"
                            :class="{ selected: (song == currentSong && isPlaying) }"
                            @click="play(index)"
                        >
                            <v-icon
                                v-if="song != currentSong || !isPlaying"
                                small
                                class="play mr-2"
                            >
                                mdi-play
                            </v-icon>
                            <v-icon
                                v-else-if="song == currentSong && isPlaying"
                                small
                                class="pause mr-2"
                            >
                                mdi-pause
                            </v-icon>
                            <img
                                class="img"
                                :src="song.imagePath"
                                :alt="song.name"
                            >
                            <span class="title-song">
                                <b>{{ song.name }}</b> - {{ song.artist }}
                            </span>
                            <v-menu
                                offset-y
                                v-if="song != currentSong"
                            >
                                <template #activator="{ on, attrs }">
                                    <v-btn
                                        v-bind="attrs"
                                        v-on="on"
                                        icon
                                        small
                                        class="next"
                                    >
                                        <v-icon small>
                                            mdi-dots-vertical
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <v-list>
                                    <v-list-item @click="playThen(index)">
                                        <v-icon
                                            small
                                            class="mr-2"
                                        >
                                            mdi-playlist-music
                                        </v-icon>
                                        Jouer ensuite
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </v-card>
                        <p
                            v-if="!filterSongs.length"
                            class="no-results"
                        >
                            Aucune musique :(
                        </p>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { formatTimer } from '../helpers/timer';
import ColorThief from '../../node_modules/colorthief/dist/color-thief.umd';
import FavoriteChip from './parts/FavoriteChip';
import chroma from 'chroma-js';

export default {
    name: 'Player',
    data: function () {
        return {
            songs: [
                {
                    name: 'Goodbye',
                    artist: 'Arezra',
                    imagePath: require('../assets/images/goodbye-arezra.jpg'),
                    path: require('../assets/songs/goodbye-arezra.mp3'),
                    favoriteMarked: false,
                },
                {
                    name: 'Tinted eyes',
                    artist: 'DVBBS',
                    imagePath: require('../assets/images/tintedeyes-dvbbs.jpg'),
                    path: require('../assets/songs/tintedeyes-dvbbs.mp3'),
                    favoriteMarked: false,
                },
                {
                    name: 'B.Y.O.B',
                    artist: 'System Of A Down',
                    imagePath: require('../assets/images/byob.jpg'),
                    path: require('../assets/songs/byob.mp3'),
                    favoriteMarked: false,
                },
                {
                    name: 'Dolly Song (Devil\' Cup)',
                    artist: 'Vize x LEONY',
                    imagePath: require('../assets/images/dollysong.jpg'),
                    path: require('../assets/songs/dollysong.mp3'),
                    favoriteMarked: false,
                }
            ],
            currentSong: {},
            isFirstSong: false,
            isLastSong: false,
            audio: false,
            muted: false,
            isPlaying: false,
            volume: 0.5,
            currentTimer: '--:--',
            audioMaxTimer: '--:--',
            moreItems: [
                {
                    title: 'Artist infos',
                    action: 'openArtistInfos'
                }
            ],
            favoritesList: [],
            search: '',
            playerBgColors: [30, 30, 30]
        };
    },
    components: {
        FavoriteChip,
    },
    methods: {
        play(index) {
            if (this.isPlaying) {
                this.playerPause();
            }
            this.currentSong = this.songs[index] ?? this.songs[this.getFirstIndex()];
            this.currentSong.index = this.songs[index] ? index : this.getFirstIndex();
            this.audio = new Audio(this.currentSong.path);
            this.audio.volume = this.volume;
            this.audio.muted = this.muted;
            this.audio.percent = 0;
            this.playerPlay();
            this.checkSiblings();
            this.changeColors();
        },
        playerPlay() {
            this.isPlaying = true;
            this.listenersWhenPlay();
            this.audio.play();
        },
        playerPause() {
            this.isPlaying = false;
            this.audio.pause();
        },
        getFirstIndex() {
            return Object.keys(this.songs)[0];
        },
        checkSiblings() {
            this.isFirstSong = (this.songs[this.currentSong.index - 1] == undefined);
            this.isLastSong = this.isLast();
        },
        isLast() {
            return (this.songs[this.currentSong.index + 1] == undefined);
        },
        next() {
            this.play(this.currentSong.index + 1);
        },
        previous() {
            this.play(this.currentSong.index - 1);
        },
        mute() {
            this.audio.muted = !this.audio.muted;
            this.muted = this.audio.muted;
        },
        volumeChange(event) {
            this.audio.volume = this.volume = event / 100 + 0.5;
            if (this.audio.volume == 0 || (this.audio.volume != 0 && this.muted == 1)) {
                this.mute();
            }
        },
        listenersWhenPlay() {
            this.audio.addEventListener('timeupdate', () => {
                let audioCurrentTime = this.audio.currentTime;
                this.currentTimer = formatTimer(audioCurrentTime);
                this.audio.percent = (audioCurrentTime * 100) / this.audio.duration;
                this.audioMaxTimer = formatTimer(this.audio.duration);
            });
            if (!this.isLast()) {
                this.audio.addEventListener(
                    'ended',
                    function () {
                        this.next();
                    }.bind(this)
                );
            }
        },
        changeAudioTime(event) {
            this.audio.currentTime = event * this.audio.duration / 100;
        },
        changeColors() {
            let img = document.querySelector('.image img');
            img.addEventListener('load', () => {
                let colorThief = new ColorThief();
                let colors = colorThief.getPalette(img);
                this.playerBgColors = chroma.mix('#303030', 'rgb(' + colors[3][0] + ',' + colors[3][1] + ',' + colors[3][2] + ')', 0.25, 'rgb').rgb();
                let body = document.querySelector('#app');
                body.style.backgroundColor = chroma.mix('#303030', 'rgb(' + colors[5][0] + ',' + colors[5][1] + ',' + colors[5][2] + ')', 0.25, 'rgb').hex();
            });
        },
        addToFavorite(index) {
            this.songs[index].favoriteMarked = !this.songs[index].favoriteMarked;
        },
        remove(index) {
            this.addToFavorite(index);
        },
        playThen(index) {
            let elem = this.songs.splice(index, 1);
            this.songs.splice(this.currentSong.index + 1, 0, elem[0]);
        }
    },
    computed: {
        favorites() {
            let favorites = [];
            for (const song of this.songs) {
                if (song.favoriteMarked) {
                    favorites.push(song);
                }
            }
            return favorites;
        },
        filterSongs() {
            if (!this.search || this.search.length < 3) {
                return this.songs;
            } else {
                return this.songs.filter((elt) => elt.artist.toLowerCase().includes(this.search.toLowerCase()) || elt.name.toLowerCase().includes(this.search.toLowerCase()));
            }
        },
    },
    watch: {
        // Watch
        favorites(favorites) {
            this.favoritesList = favorites;
        }
    },
    mounted() {
        this.currentSong = this.songs[this.getFirstIndex()];
        this.currentSong.index = 0;
        this.audio = new Audio(this.currentSong.path);
        this.audio.volume = this.volume = 0.5;
        this.audio.percent = 0;
        this.isFirstSong = true;
        this.changeColors();
    },
};
</script>

<style lang="scss">
.player {
    border-radius: 20px !important;
    position: relative;

    .sound {
        position: absolute;
        right: 18px;
        top: 61%;
        transform: translateY(-50%);

        i,
        button {
            z-index: 5;
        }

        .slider {
            visibility: hidden;
            opacity: 0;
            transition: 0.3s ease;
        }

        &:hover {
            .slider {
                visibility: visible;
                opacity: 1;
            }
        }
    }

    .slider {
        position: absolute;
        right: -17px;
        padding: 25px;
        background-color: #121212;
        border-radius: 25px;
        top: -90%;
        transform: translateY(-75%);
        padding-bottom: 50px;
        z-index: 1;
    }

    .image {
        max-width: 300px;
        max-height: 300px;
        margin: auto;
        margin-bottom: 12px;

        img {
            width: 100%;
            height: 100%;
            border-radius: 20px !important;
        }
    }

    .title {
        text-align: center;
        margin-bottom: 4px;
    }

    .artist {
        text-align: center;
        opacity: 0.9;
        font-size: 13px;
        margin-bottom: 14px;

        a {
            text-decoration: none;
        }

        &:hover {
            a {
                text-decoration: underline;
            }
        }
    }

    .progress-bar {
        // padding-top: 14px;
        margin-bottom: 14px !important;

        .v-slider__thumb {
            width: 6px;
            height: 6px;
            transform: translateY(-3px) translateX(4px);
        }

        .times {
            p {
                font-size: 12px;
            }
        }
    }

    .buttons {
        button,
        v-btn {
            background-color: transparent;
            box-shadow: none;
            display: block;
            width: 50px;

            i {
                margin: auto;
                display: block;
            }

            &.hidden {
                opacity: 0;
                visibility: hidden;
            }
        }
    }
}
.v-text-field__details {
    display: none !important;
}
.no-results {
    margin-top: 15px;
    text-align: center;
}
</style>
